(() => {
  const initGallery = (root) => {
    const galleries = root.matches?.('.keene-send__inspiration')
      ? [root]
      : root.querySelectorAll('.keene-send__inspiration');

    for (const gallery of galleries) {
      if (gallery.dataset.sliderInitialized === 'true') continue;

      const track = gallery.querySelector('[data-send-slider]');
      const controls = gallery.querySelector('[data-send-slider-controls]');
      const previous = gallery.querySelector('[data-send-slider-prev]');
      const next = gallery.querySelector('[data-send-slider-next]');
      const progress = gallery.querySelector('[data-send-slider-progress]');
      const fill = gallery.querySelector('[data-send-slider-progress-fill]');
      if (!track || !controls || !previous || !next || !progress || !fill) continue;

      gallery.dataset.sliderInitialized = 'true';

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = maxScroll <= 2;
        if (controls.hidden) return;

        const position = Math.max(0, Math.min(track.scrollLeft, maxScroll));
        const fraction = position / maxScroll;
        const visiblePercent = Math.min(100, track.clientWidth / track.scrollWidth * 100);
        fill.style.width = `${visiblePercent}%`;
        fill.style.left = `${fraction * (100 - visiblePercent)}%`;
        progress.setAttribute('aria-valuenow', String(Math.round(fraction * 100)));
        previous.disabled = position <= 2;
        next.disabled = position >= maxScroll - 2;
      };

      const move = (direction) => {
        const card = track.querySelector('.keene-send__promo');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);
      window.addEventListener('load', update, { once: true });
      gallery.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => resizeObserver.disconnect(), { once: true });
      update();
    }
  };

  initGallery(document);
  document.addEventListener('shopify:section:load', (event) => initGallery(event.target));
})();
